import { render, staticRenderFns } from "./FormulaSeven.vue?vue&type=template&id=5db5eafe&scoped=true"
import script from "./FormulaSeven.vue?vue&type=script&lang=js"
export * from "./FormulaSeven.vue?vue&type=script&lang=js"
import style0 from "./FormulaSeven.vue?vue&type=style&index=0&id=5db5eafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db5eafe",
  null
  
)

export default component.exports